import { render, staticRenderFns } from "./codSuccess.vue?vue&type=template&id=6c53fb65&scoped=true"
import script from "./codSuccess.vue?vue&type=script&lang=js"
export * from "./codSuccess.vue?vue&type=script&lang=js"
import style0 from "./codSuccess.vue?vue&type=style&index=0&id=6c53fb65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53fb65",
  null
  
)

export default component.exports